import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

export const Wrapper = styled.main`
  width: 100%;
  min-height: 100vh;
  margin: auto;
  background-color: ${({ theme }) => theme.darkTheme.colors.background};
`;

export const Container = styled.form`
  margin: 15px auto 0 auto;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  row-gap: 25px;

  ${({ theme }) => css`
    max-width: ${theme.breakPoint.regularPhone};
    @media (max-width: ${theme.breakPoint.regularPhone}) {
      margin: 15px;
    }
  `}

  h1 {
    font-weight: 700;
    font-size: 24px;
    margin: 0;
  }

  p {
    margin: 0;
  }
`;

export const LinkStyled = styled(Link)`
  color: #ccc;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 0;
  :hover {
    text-decoration: none;
  }
`;

export const ChannelsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  label {
    display: block;
    position: relative;
    margin: 0;
    padding: 12px 10px 12px 40px;
    line-height: 25px;
    background-color: #323132;
    border-radius: 5px;
    :hover {
      cursor: pointer;
    }
  }
`;

export const RadioButton = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  :checked ~ span:after {
    display: block;
  }
`;

export const RadioButtonMark = styled.span`
  position: absolute;
  top: 14px;
  left: 10px;
  height: 20px;
  width: 20px;
  background-color: #323132;
  border: 1px solid #5f5d5f;
  border-radius: 5px;
  padding: 3.2px;

  ::after {
    content: "";
    position: absolute;
    display: none;
    width: 12px;
    height: 12px;
    background-color: #cff16b;
    border-radius: 2px;
  }
`;
